import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadRoutingModule } from './upload-routing.module';
import { UploadDocumentComponent } from '../../components/upload-document/upload-document.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessageService } from 'primeng/api';
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [UploadDocumentComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    ButtonModule,
    ProgressBarModule,
    UploadRoutingModule,
    DialogModule,
    DropdownModule,
],
  exports: [UploadDocumentComponent],
  providers: [MessageService]
})
export class UploadModule { }
